import { markRaw, shallowReactive, type Component } from 'vue'
import TeaserDefault from './TeaserDefault.vue'

export type TeaserMap = Record<string, Component>

// reactive, so a registration after <agent-search-results> mounted still re-renders it
const registry = shallowReactive<TeaserMap>({})

/**
 * Registers a teaser component for a teaser key (the Pimcore route name), globally for all instances.
 * Key `default` replaces the built-in teaser for every result without its own teaser.
 */
export function registerTeaser(key: string, component: Component): void {
    registry[key] = markRaw(component)
}

export function unregisterTeaser(key: string): void {
    delete registry[key]
}

/** Local map first, then the global registry, then the registered default, then the built-in teaser. */
export function resolveTeaser(key: string, local?: TeaserMap): Component {
    return local?.[key] ?? registry[key] ?? local?.default ?? registry.default ?? TeaserDefault
}
